/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from "../../framework/API/api"
import { ApplicationConfigurationKeys, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";
import { ImageBrowser } from "../../framework/forms/helpercomponents/selectFile/ImageBrowser";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { ConfirmAlertOk, ConfirmDeleteAlert } from "../../ConfirmAlert";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import MyStatusCell from "../../components/MyStatusCell";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import ToastNotification from "../../components/ToastNotification";

const NodeEditForm = (props) => {

    const { item = {}, refresh, cancelEdit } = props;

    const blankDataItem = {
        ...item,
        SID: item?.SID ?? 0,
        Name: item?.copy ? "Copy of " + item?.Name : item?.Name ?? "",
        DisplayTitle: item?.DisplayTitle ?? "",
        TranslatedDisplayTitle: item?.TranslatedDisplayTitle ?? "",
        Description: item?.Description ?? "",
        TranslatedDescription: item?.TranslatedDescription ?? "",
        ImageGroup: item?.ImageGroup ?? {},
        ImageUrl: item?.ImageUrl ?? "",
        ParentalRating: item?.ParentalRating ?? {},
        ExternalReference: item?.ExternalReference ?? "",
        Archive: item?.Archive ?? false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [parentNodes, setParentNodes] = useState([]);
    const [parentNode, setParentNode] = useState({});
    const [imageGroups, setImageGroups] = useState([]);
    const [imageSelected, setImageSelected] = useState(false);
    const [catalogues, setCatalogues] = useState([]);
    const [parentalrating, setParentalRating] = useState([]);
    const [availableNodes, setAvailableNodes] = useState([]);
    const [tabNumber, setTabNumber] = React.useState("1");
    const [providerGridData, setProviderGridData] = useState([]);
    const [restrictedPgRatingGridData, setRestrictedPgRatingGridData] = useState([]);
    const [showCollectionProvider, setShowCollectionProvider] = useState(false);
    const [showCollectionPgRating, setShowCollectionPgRating] = useState(false);
    const lang = useTranslation();
    const applicationConfigImrUrl = useRef();

    useEffect(() => {
        loadCombo();
        if (item?._id) {
            loadEditData();
        }
    }, []);

    const loadCombo = async () => {
        let catalougeRes = await API.getDataLookup(ENTITYNAME.Catalogues, { sort: { Description: 1 }, query: ['Archive', '!=', true] });
        setCatalogues(catalougeRes.data);
        let imagegroupRes = await API.getDataLookup(ENTITYNAME.ImageGroups, { sort: { Name: 1 }, query: ['Archive', '!=', true] });
        setImageGroups(imagegroupRes.data);
        let parentalratingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 }, query: ['Archive', '!=', true] });
        setParentalRating(parentalratingRes.data);

        let parentRes = await API.getDataLookup(ENTITYNAME.Nodes);
        if (parentRes.success) {
            const nullItem = { _id: null, SID: Math.random(), Archive: false, Name: "root", parentNode: null };
            setParentNodes([nullItem]);
            setAvailableNodes(parentRes.data);
            if (item?.SID == 0) {
                setParentNode(nullItem);
            }
            if (item.copy || item.SID > 0 || item?.ParentNode) {
                const filteredParents = parentRes.data.filter(x => x?.Catalogue?._id == item?.Catalogue?._id);
                setParentNodes([nullItem, ...filteredParents]);
                setParentNode(item.ParentNode == null ? nullItem : parentRes.data.find(x => x._id == item.ParentNode));
            }
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

        if (item?.SID == 0) {
            setDataItem({
                ...dataItem, ImageGroup: utility.getDefaultItem(imagegroupRes.data),
                ImageGroup: item?.ImageGroup && Object.keys(item?.ImageGroup).length > 0 ? item?.ImageGroup : utility.getDefaultItem(imagegroupRes.data),
                Catalogue: item?.Catalogue && Object.keys(item?.Catalogue).length > 0 ? item?.Catalogue : utility.getDefaultItem(catalougeRes.data)
            })
        }

        applicationConfigImrUrl.current = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.ImageUrl1BaseAddress) ?? null;
    };

    const loadEditData = async () => {
        if (item?.Providers?.length > 0) {
            let providerRes = await API.getData(ENTITYNAME.OttProvider, { query: ["_id", "in", item.Providers] })
            setProviderGridData(providerRes.data);
        }

        if (item?.RestrictedPgRatings?.length > 0) {
            const pgratingRes = await API.getData(ENTITYNAME.PGRating, { query: ["_id", "in", item.RestrictedPgRatings] });
            setRestrictedPgRatingGridData(pgratingRes.data);
        }

        if (item?.ParentNode) {
            const parentNodeRes = await API.getData(ENTITYNAME.Nodes, { query: ["_id", "=", item.ParentNode] });
            setParentNode(parentNodeRes.data?.length > 0 ? parentNodeRes.data[0] : {});
        }
    };

    const onChange = (e) => {
        console.log(e.target.name)
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else if (e.target.name === "Catalogue") {
            const selectedCatalogue = e.target.value;
            setDataItem({ ...dataItem, Catalogue: selectedCatalogue });
            const rootNode = parentNodes[0];

            if (!selectedCatalogue || !selectedCatalogue._id) {
                setParentNodes([rootNode]);
                setParentNode(rootNode);
                return;
            }
            const filteredParents = availableNodes.filter(
                node => node?.Catalogue?._id === selectedCatalogue._id
            );
            setParentNode(rootNode);
            setParentNodes([rootNode, ...filteredParents]);
            return;
        }
        else if (e.target.name == "parentNode") {
            setParentNode(e.target.value);
        } else if (e.target.name == "ImageGroup") {
            setDataItem({
                ...dataItem, [e.target.name]: e.target.value,
                ImageUrl: (e.target.value.Name.toLowerCase() == "ris" && dataItem.ImageUrl.length == 0) ? applicationConfigImrUrl.current : dataItem.ImageUrl
            });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const isValid = () => {
        if (!dataItem.Name || dataItem.Name == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (!dataItem.DisplayTitle || dataItem.DisplayTitle == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_display_title_error_message });
            return false;
        }
        if (!dataItem.Catalogue || Object.keys(dataItem.Catalogue).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_catalogue_error_message });
            return false
        }
        if (!parentNode || Object.keys(parentNode).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_parent_error_message });
            return false
        }
        if (dataItem._id && (!dataItem.ExternalReference || dataItem.ExternalReference == "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_external_reference_error_message });
            return false
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        const saveData = {
            _id: !item?.copy ? dataItem._id : null,
            SID: !item?.copy ? dataItem.SID ?? 0 : 0,
            Name: dataItem?.Name ?? "",
            Catalogue: dataItem?.Catalogue && Object.keys(dataItem?.Catalogue)?.length > 0 ? {
                _id: dataItem?.Catalogue?._id,
                Description: dataItem?.Catalogue?.Description
            } : {},
            ImageUrl: dataItem?.ImageUrl ?? "",
            ImageGroup: dataItem?.ImageGroup && Object.keys(dataItem?.ImageGroup)?.length > 0 ? {
                _id: dataItem?.ImageGroup?._id,
                Name: dataItem?.ImageGroup?.Name
            } : {},
            ParentalRating: dataItem?.ParentalRating && Object.keys(dataItem?.ParentalRating)?.length > 0 ?
                {
                    _id: dataItem?.ParentalRating?._id,
                    Description: dataItem?.ParentalRating?.Description
                } : {},
            ExternalReference: dataItem?.ExternalReference ?? null,
            ParentNode: parentNode?._id ?? null,
            Archive: dataItem.Archive ?? false,
            DisplayTitle: dataItem?.DisplayTitle ?? "",
            TranslatedDisplayTitle: dataItem?.TranslatedDisplayTitle ?? "",
            Providers: providerGridData?.length > 0 ? providerGridData?.map(x => x._id) : [],
            RestrictedPgRatings: restrictedPgRatingGridData?.length > 0 ? restrictedPgRatingGridData?.map(x => x._id) : [],
            Description: dataItem?.Description ?? "",
            TranslatedDescription: dataItem?.TranslatedDescription ?? "",
        }
        console.log(saveData);
        let res = await API.saveNode(saveData);
        if (res.success) {
            let logData = { event: res.message.includes("updated") ? LOGEVENT.UPDATE_NODE : LOGEVENT.CREATE_NODE, module: MODULE.NODES, data: res.data, message: res.message };
            await API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.Nodes);
            cancelEdit();
            refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const deleteProviderSelectedValue = (dataItem) => {
        setProviderGridData(providerGridData.filter((obj) => dataItem._id != obj._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
    }
    const deletePgRatingSelectedValue = (dataItem) => {
        setRestrictedPgRatingGridData(restrictedPgRatingGridData.filter((obj) => dataItem._id != obj._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
    }

    const MyCommandProviderCell = (props) => (
        <td style={{ padding: "3px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteProviderSelectedValue(props.dataItem), () => { })} />
        </td>
    )
    const MyCommandPgRatingCell = (props) => (
        <td style={{ padding: "3px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deletePgRatingSelectedValue(props.dataItem), () => { })} />
        </td>
    );

    const handleProviderData = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, providerGridData, "Description")
        setProviderGridData([...providerGridData, ...newData]);
    }
    const handlePgRatingData = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, restrictedPgRatingGridData, "Description")
        setRestrictedPgRatingGridData([...restrictedPgRatingGridData, ...newData]);
    }
    const deleteAllProviders = () => {
        ConfirmAlertOk(
            () => setProviderGridData([]),
            lang.confirm_alert_delete_all_message,
            lang.are_you_sure_do_you_want_to_delete_all_label,
            lang.delete_all_label
        );
    };
    const deleteAllPgRatings = () => {
        ConfirmAlertOk(
            () => setRestrictedPgRatingGridData([]),
            lang.confirm_alert_delete_all_message,
            lang.are_you_sure_do_you_want_to_delete_all_label,
            lang.delete_all_label
        );
    };

    const Mystatuscell = (props) => {
        let tileBackColor = props.dataItem.IsActive ? "#63aa43" : "#E72929";
        return <MyStatusCell title={props.dataItem.IsActive ? "Active" : "Deactive"} tileBackColor={tileBackColor} />
    }

    return (
        <>
            <BossDialog
                title={item?._id ? item?.Name : lang.create_node_dialog_header}
                onClose={props.cancelEdit}
                width="900px"
            >
                <div className="row align-items-center">
                    <div className="col" >
                        <EditPageHeader
                            onSubmit={handleSubmit}
                            onCancel={props.cancelEdit}
                            showTitle={false}
                        />
                    </div>
                    {item?._id && (
                        <div className="col-auto d-flex align-items-center">
                            <label className="mb-0 mr-2">{lang.node_csid_label}:</label>
                            <div className="d-flex align-items-center px-2" disabled style={{ width: "120px", height: "30px", border: "1px solid rgb(197 200 201 / 88%)", borderRadius: "4px", backgroundColor: "#eaeef1", fontSize: "13px" }} > {item?.CSID}</div>
                        </div>
                    )}
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <label>{lang.name_label} *</label>
                        <input
                            name="Name"
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.Name}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.display_title_label} *</label>
                        <input
                            name={"DisplayTitle"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.DisplayTitle}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.translated_display_title_label}</label>
                        <input
                            name={"TranslatedDisplayTitle"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.TranslatedDisplayTitle}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.description_label}</label>
                        <input
                            name="Description"
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.Description}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.translated_description_label}</label>
                        <input
                            name="TranslatedDescription"
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.TranslatedDescription}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.catalogue_label} *</label>
                        <DropDownList
                            data={catalogues}
                            name={"Catalogue"}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Catalogue}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.vod_channel_label} *</label>
                        <DropDownList
                            data={parentNodes}
                            name={"parentNode"}
                            textField="Name"
                            dataItemKey="_id"
                            value={parentNode}
                            onChange={onChange}
                        />
                        <p className="list-unstyled blockquote-footer">{lang.note_for_parent_select_root_label}</p>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.parental_rating_label}</label>
                        <DropDownList
                            name="ParentalRating"
                            data={parentalrating}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.ParentalRating}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.image_group_label}</label>
                        <DropDownList
                            data={imageGroups}
                            name={"ImageGroup"}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.ImageGroup}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    {dataItem._id && <div className="col-6">
                        <label>{lang.external_reference_label} *</label>
                        <input
                            name={"ExternalReference"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.ExternalReference}
                        />
                    </div>}
                    <div className={dataItem._id ? "col-6" : "col-12"}>
                        <label>{lang.image_url_label} </label>
                        <ImageBrowser name={'ImageUrl'} value={dataItem.ImageUrl} onChange={onChange} setImageSelected={setImageSelected} hidePosterLibrary={true} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-6" style={{ marginTop: "22px" }}>
                        <input
                            type="checkbox"
                            name="Archive"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label htmlFor="TabView" className="pl-1">{lang.archive}</label>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className='col-12'>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={tabNumber}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleTabChange} aria-label="tabs example">
                                        <Tab label={lang.provider_label} value="1" />
                                        <Tab label={lang.pg_rating_label} value="2" />
                                    </TabList>
                                </Box>
                                <TabPanel value={"1"}>
                                    <div className='row'>
                                        <div className="col-12">
                                            <AddRoundButton onClick={() => setShowCollectionProvider(true)} />
                                            <RoundButton icon="trash" title={lang.delete_all_button_tooltip} onClick={deleteAllProviders} />
                                            <span className='float-right' style={{ marginTop: "15px" }}>{lang.provider_label}</span>
                                            <Grid style={{ height: "25vh", marginTop: "5px" }} data={providerGridData}>
                                                <GridColumn editable={false} cell={MyCommandProviderCell} width="40px" />
                                                <GridColumn field="LogoUrl" title={lang.provider_label} editable={false} cell={ImageCell} width={"100px"} />
                                                <GridColumn field="Description" title={lang.name_column} editable={false} width={200} />
                                                <GridColumn field="IsActive" title={lang.status_label} editable={false} cell={Mystatuscell} width={"150px"} />
                                                <GridColumn field="StartDate" title={lang.start_date_label} editable={false} cell={DateOnlyCell} width={"150px"} />
                                                <GridColumn field="EndDate" title={lang.end_Date_label} editable={false} cell={DateOnlyCell} width={"150px"} />
                                            </Grid>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={"2"}>
                                    <div className='row'>
                                        <div className="col-12">
                                            <AddRoundButton onClick={() => setShowCollectionPgRating(true)} />
                                            <RoundButton icon="trash" title={lang.delete_all_button_tooltip} onClick={deleteAllPgRatings} />
                                            <span className='float-right' style={{ marginTop: "15px" }}>{lang.pg_rating_label}</span>
                                            <Grid style={{ height: "25vh", marginTop: "5px" }} data={restrictedPgRatingGridData}>
                                                <GridColumn editable={false} cell={MyCommandPgRatingCell} width="80px" />
                                                <GridColumn field="Description" title={lang.pg_rating_column} editable={false} />
                                                <GridColumn field="Language.Description" title={lang.language_column} editable={false} />
                                                <GridColumn field="ParentPgRating.Description" title={lang.parent_pg_rating_label} editable={false} />
                                            </Grid>
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </div>
                </div>
                {showCollectionProvider && <CollectionSelection setDataList={handleProviderData} closeForm={() => setShowCollectionProvider(false)} entityname={ENTITYNAME.OttProvider} width={"50vw"} title={lang.select_provider_collection_header} addButtonTitle={lang.select_collection_button_text} />}
                {showCollectionPgRating && <CollectionSelection setDataList={handlePgRatingData} closeForm={() => setShowCollectionPgRating(false)} entityname={ENTITYNAME.PGRating} width={"50vw"} title={lang.select_pgrating_collection_header} addButtonTitle={lang.select_collection_button_text} />}
            </BossDialog>
        </>)
};

export default NodeEditForm;